<template>
  <div class="page">
    <header class="logo">
        <div class="cir1">
        </div>
      <div class="cir2"></div>
      <img src="../assets/images/logo.png" alt="">
    </header>
    <div class="title">专业报告</div>
    <div class="sub-title">报告编号：{{ data.code }}</div>
    <section>
      <div class="section-title">客户档案</div>
      <div class="user-content">
        <ul>
          <li>姓名：{{data.name}}</li>
          <li>性别：{{data.sex}}</li>
          <li>年龄：{{data.age}}</li>
          <li>电话：{{data.phone}}</li>
          <li>职业：{{data.occupation}}</li>
        </ul>
          <p>过敏史：{{data.allergy}}</p>
      </div>
    </section>
     <section>
      <div class="section-title">检测结果一览表</div>
      <table class="result-table">
        <thead>
          <th>检测项</th>
          <th>分数</th>
          <th>参考范围 </th>
          <th>程度</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data.datalist " :key="index">
            <td>{{item.items}}</td>
            <td :style="{color: getColor(item.sort)}">{{item.value}}</td>
            <td>80~100</td>
            <td :style="{color: getColor(item.sort)}">{{item.level}}</td>
            </tr>
        </tbody>
      </table>
    </section>
     <section>
      <div class="section-title">各项详情</div>
      <ul>
        <li v-for="(info, index) in data.datalist" :key="index" class="info-wrapper" :class="{'info-hidden': switchIndex != index}" @click="showInfo(index)">
          <p class="info-title">{{info.items}} <span></span></p>
          <div class="info-content">
            <div class="chart">
              <div class="base">
                <ul>
                  <li>80</li>
                  <li>60</li>
                  <li>40</li>
                  <li>20</li>
                  <li>0</li>
                </ul>
              </div>
              <div class="average" :style="{height: info.cloudvalue + '%'}" :data-value="info.cloudvalue"></div>
              <div class="last" :style="{height: info.lastvalue + '%'}" :data-value="info.lastvalue"></div>
              <div class="now" :style="{height: info.value + '%'}" :data-value="info.value"></div>
            </div>
              <p class="chart-title">数据对比直方图</p>
            <div class="pyramid">
              <div class="perten" v-for="(per, index) in info.pertenlist" :key="index" :data-value="per.perten+'%'" :class="{here: per.state == 2}" :style="{width: 14 + per.perten * 0.75 + '%'}">{{per.name}} <span></span></div>
            </div>
            <p class="pyramid-title">数据占比金字塔</p>
            <div class="intro-content">
              <h3 v-if="info.intro">成因分析</h3>
              <p v-if="info.intro">{{ info.intro }}</p>
              <h3 v-if="info.experts">专家提示</h3>
              <p v-if="info.experts">{{ info.experts }}</p>
              <h3 v-if="info.suggest">护理建议</h3>
              <p v-if="info.suggest">{{ info.suggest }}</p>
            </div>
          </div>
          </li>
      </ul>
    </section>
     <section>
      <div class="section-title">给我评分</div>
      <div class="content heart-content">
        <div v-for="i in 5" :key="i" class="heart" :class="{'heart-active': i <= star}" @click="evaluate(i)"></div>
      </div>
    </section>
    <footer>
      <p>报告已经看完啦～</p>
      <p>好的东西需要分享，快收藏或分享给您的好友吧～</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'WXReportDetail',
  data () {
    return {
      data: {},
      star: 0,
      switchIndex: 0
    }
  },
  async created () {
    const id = this.$route.query.id
    const sign = this.$route.query.sign
    const params = {
      id,
      sign
    }
    // https://data.wax-apple.cn/Index/Report/Pifu_play?id=315558&sign=5a8bbbd84b2fec7879a2a14f5b15312b
    // 报告信息
    const data = await this.$axios.get('/Index/Report/pifu_profes', { params })
    data.data.datalist.forEach(
      x =>
        (x.pertenlist = x.pertenlist.sort((a, b) =>
          b.name.localeCompare(a.name)
        ))
    )
    this.data = data.data
  },
  computed: {},
  methods: {
    getResult (value) {
      return ['日常护理', '一般护理', '轻度护理', '修复护理'][value - 1]
    },
    getColor (value) {
      return ['#999999', '#999999', '#f1811d', '#ca0000'][value - 1]
    },
    showInfo (index) {
      this.switchIndex = index
    },
    async evaluate (index) {
      if (this.star) return
      this.star = index
    }
  }
}
</script>
<style lang="stylus" scoped>
.page {
  position: relative;
  margin: 0 auto;
  max-width: 720px;
  width: 100%;
}

.heart-content {
  letter-spacing -10px
}
.heart {
  background url('../assets/images/report/no-heart.png') 0 0 / 100% 100%
  width calc(20% - 20px)
  padding-top calc(20% - 20px)
  margin 10px
  display inline-block

  &.heart-active {
    background url('../assets/images/report/heart.png') 0 0 / 100% 100%
  }
}

header {
  width: 100%;
  text-align: center;

  img {
    margin-top: 10px;
    width: 50%;
    max-width: 300px;
  }

  .cir1, .cir2 {
    position: absolute;
    z-index: -100;
    width: 90%;
    height: 300px;
    top: -200px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.05);
    margin-left: 15px;
  }

  .cir2 {
    margin-left: 30px;
  }
}

.title {
  text-align: center;
  margin-top: 50px;
}

.sub-title {
  font-size: 14px;
  text-align: center;
  padding: 10px;
  color: #888;
}

section {
  position: relative;
  margin: 40px 10px 0;
  padding: 10px;
  width: calc(100% - 20px);
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);

  .section-title {
    position: absolute;
    top: -14px;
    left: -7px;
    font-size: 16px;
    display: inline-block;
    padding: 5px 10px;
    border-radius: 20px;
    box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.09);
    background: linear-gradient(to right, rgb(232, 232, 232), rgb(208, 208, 208));
  }

  &:nth-of-type(1) {
    ul {
      padding: 10px 0 0 5%;
    }

    li {
      padding: 10px 0;
      display: inline-block;
      font-size: 14px;

      &:nth-of-type(3n - 1) {
        width: 20%;
      }

      &:nth-of-type(3n - 2) {
        width: 43%;
      }

      &:nth-of-type(5) {
        width: 40%;
      }
    }

    p {
      font-size: 14px;
      padding: 10px 5%;
    }
  }

  &:nth-of-type(2) {
    font-size: 14px;
    padding-top: 30px;
    padding-bottom: 20px;

    .result-table {
      width: 100%;

      th, td {
        outline: 1px solid #eee;
        text-align: center;
        padding: 7px 0;
      }

      th {
        &:nth-of-type(1) {
          width: 30%;
        }

        &:nth-of-type(2) {
          width: 15%;
        }

        &:nth-of-type(3) {
          width: 20%;
        }

        &:nth-of-type(4) {
          width: 30%;
        }
      }

      td {
        color: #999;
      }
    }
  }

  &:nth-of-type(3) {
    padding-top: 25px;

    .info-hidden {
      > .info-content {
        height: 0;
      }
      >.info-title {
         span {
           transform: rotate(135deg);
         }
      }
      .perten {
        width 0 !important
      }
      .average, .last, .now {
        height 0 !important
      }
    }

    .info-content {
      overflow: hidden;
      transition: all 1s ease;
    }

    .pyramid {
      margin-top: 30px;

      .perten {
        color: #ffffff;
        position: relative;
        font-size: 12px;
        text-align: center;
        height: 25px;
        line-height: 25px;
        font-weight: 100;
        background: linear-gradient(to right, #fcaf65, #e86221);
        margin: 1% auto 0;
        transition all 1s ease

        &:before {
          content: attr(data-value);
          position: absolute;
          width: 50px;
          text-align: right;
          left: -55px;
          color: #999;
        }

        &.here {
          background: linear-gradient(to right, #eb2b5a, #d20100);

          span {
            color: #2b2b2b;
            position: absolute;
            right: 25%;
            top: -20px;

            &:before {
              content: '';
              display: block;
              position: absolute;
              width: 20px;
              height: 20px;
              border-top: 1px solid #000;
              border-left: 1px solid #000;
              transform: skew(145deg);
            }

            &:after {
              content: '您在这区域';
              display: block;
              width: 100px;
              font-size: 12px;
              position: absolute;
              left: 12px;
              top: -11px;
            }
          }
        }
      }
    }

    .intro-content {
      font-size: 14px;
      line-height: 1.4;
      padding: 0 12px 60px;

      h3 {
        font-size: 16px;
        font-weight: bold;
        color: #000;
        display: block;
        margin-top: 30px;
      }

      p {
        text-indent: 25px;
        line-height: 1.6;
      }
    }

    .info-wrapper + .info-wrapper {
      margin-top 20px
    }

    .info-title {
      border-bottom: 1px solid #d3d3d3;
      font-size: 16px;
      color: #2b2b2b;
      padding-left: 10px;
      height: 30px;
      line-height: 25px;
      position: relative;

      span {
        border-top: 1px solid #2b2b2b;
        border-right: 1px solid #2b2b2b;
        display: block;
        width: 10px;
        height: 10px;
        transform: rotate(-45deg);
        transform-origin: center center;
        position: absolute;
        right: 25px;
        top: 8px;
      }
    }

    .chart-title, .pyramid-title {
      margin-top: 40px;
      font-size: 14px;
      text-align: center;
      color: #2b2b2b;
    }

    .pyramid-title {
      margin-top: 20px;
      padding-bottom: 20px;
    }

    .chart {
      width: 75%;
      position: relative;
      margin: 30px auto 0;
      height: 150px;

      &:after, &:before {
        content: '';
        position: absolute;
        display: block;
        width: 0;
        height: 0;
      }

      &:after {
        right: -2px;
        bottom: -3px;
        border-top: 4px solid transparent;
        border-left: 8px solid #999;
        border-bottom: 4px solid transparent;
      }

      &:before {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 8px solid #999;
        left: -3px;
        top: -2px;
      }

      .base {
        height: 100%;
        border-left: 2px solid #999;
        border-bottom: 2px solid #999;

        ul {
          padding: 0;
          margin: 0;
          position: absolute;
          bottom: 0;
          left: -20px;
        }

        li {
          font-size: 14px;
          text-align: right;
          color: #999;
          margin-top: 100%;
        }
      }

      .average, .last, .now {
        position: absolute;
        bottom: 2px;
        border-right: 20px solid transparent;
        transition all 1s ease

        &:after {
          content: attr(data-value);
          position: absolute;
          right: -16px;
          top: -12px;
          color: #999;
          font-size: 12px;
        }

        &:before {
          color: #999;
          font-size: 12px;
          width: 120px;
          height: 20px;
          line-height: 20px;
          display: block;
          position: absolute;
          bottom: -25px;
          right: 0;
          text-align: center;
          right: -70px;
        }
      }

      .average {
        width: 25%;
        border-image: linear-gradient(to bottom, #ffe04f, #f39107) 1;

        // background linear-gradient(to bottom #ffe04f #f39107)
        &:before {
          content: '大数据平均值';
        }
      }

      .last {
        width: 55%;
        border-image: linear-gradient(to bottom, #46d6ee, #626ab7) 1;

        &:before {
          content: '上一次检测值';
        }
      }

      .now {
        width: 85%;
        border-image: linear-gradient(to bottom, #76f6f4, #16998c) 1;

        &:before {
          content: '本次检测值';
        }
      }
    }
  }
}

footer {
  text-align: center;
  margin: 20px 10px 10px;
  font-size: 14px;
  color: #ffffff;
  background: #bbb;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);

  p {
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/WXReportDetail.vue